import { ISettingsModel } from '../models/settings.model';
import * as SettingsActions from './settings.actions';
import { Action, createReducer, on } from '@ngrx/store';

export type State = ISettingsModel;

const initialState: State = {
  users: null,
  companies: null,
  roles: null,
  jobTitles: null,
  customizedValues: null,
  outputChecks: null,
  importError: null
};

const settingsReducer = createReducer(
  initialState,
  on(SettingsActions.GetSettingsUsersDataSuccess, (state, { users, companies, roles }): State => {
    return { ...state, users, companies, roles };
  }),
  on(SettingsActions.CreateUserByUserSuccess, (state, { payload: user }): State => {
    return { ...state, users: [user, ...state.users] };
  }),
  on(SettingsActions.UpdateUserByUserSuccess, (state, { payload: user }): State => {
    return { ...state, users: state.users.map((curUser) => (user.id === curUser.id ? user : curUser)) };
  }),
  on(SettingsActions.GetCustomizedValuesSuccess, (state, { customizedValues }): State => {
    return { ...state, customizedValues };
  }),
  on(SettingsActions.AddCustomizedValueSuccess, (state, { customizedValue }): State => {
    return { ...state, customizedValues: [...state.customizedValues, customizedValue] };
  }),
  on(SettingsActions.UpdateCustomizedValueSuccess, (state, { customizedValue }): State => {
    return {
      ...state,
      customizedValues: state.customizedValues.map((v) => (v.id === customizedValue.id ? customizedValue : v))
    };
  }),
  on(SettingsActions.DeleteCustomizedValueSuccess, (state, { id }): State => {
    return { ...state, customizedValues: state.customizedValues.filter((v) => v.id !== id) };
  }),
  on(SettingsActions.ImportCustomizedValuesSuccess, (state, { newValues, importError }): State => {
    return { ...state, customizedValues: [...state.customizedValues, ...newValues], importError };
  }),
  on(SettingsActions.ClearCustomizedValuesImportError, (state): State => {
    return { ...state, importError: null };
  }),
  on(SettingsActions.GetSettingsOutputChecksSuccess, (state, { outputChecks }): State => {
    return { ...state, outputChecks };
  }),
  on(SettingsActions.GetJobTitlesSuccess, (state, { jobTitles }): State => {
    return { ...state, jobTitles };
  }),
  on(SettingsActions.UpsertJobTitleSuccess, (state, { jobTitle }): State => {
    const jobTitles = upsertById(state.jobTitles, jobTitle);
    return { ...state, jobTitles };
  })
);

export const reducer = (state: State, action: Action): State => settingsReducer(state, action);

const upsertById = <T extends { id: string }>(array: T[], item: T): T[] => {
  const map = new Map(array.map((x) => [x.id, x]));
  const existing = map.get(item.id);
  map.set(item.id, existing ? { ...existing, ...item } : item);
  return Array.from(map.values());
};
